module.exports = __webpack_public_path__ + "img/set_bgn.fd92ef1c.png";